export default "__VITE_ASSET__CmlPkKP8__"